"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var typestyle_1 = require("typestyle");
var Localize_1 = require("../../../gen-src/Localize");
var MonthMultiDayPicker_1 = require("../controls/MonthMultiDayPicker");
var TimePicker_1 = require("../controls/TimePicker");
var TimeZoneDisplay_1 = require("../controls/TimeZoneDisplay");
var Recurrence_1 = require("../Recurrence");
var TimeHhMm_1 = require("../TimeHhMm");
var StaticInitializers_1 = require("../StaticInitializers");
var TimeZoneCssStyle = { flex: '1 2 400px', marginTop: '18px' };
var TimePickerCssStyle = { flex: '1 2 165px', marginTop: '18px', marginLeft: '24px', marginBottom: '18px' };
var MonthDayPickerStyle = { flex: '1 2 165px', marginLeft: '24px' };
var MonthDayTypePickerStyle = { flex: '1 2 165px' };
var MonthMultiDayPickerStyle = { padding: '2px', width: '232px' };
var DayTypeChoice;
(function (DayTypeChoice) {
    DayTypeChoice[DayTypeChoice["Day"] = 77] = "Day";
    DayTypeChoice[DayTypeChoice["First"] = 1] = "First";
    DayTypeChoice[DayTypeChoice["Second"] = 2] = "Second";
    DayTypeChoice[DayTypeChoice["Third"] = 3] = "Third";
    DayTypeChoice[DayTypeChoice["Fourth"] = 4] = "Fourth";
    DayTypeChoice[DayTypeChoice["Fifth"] = 5] = "Fifth";
    DayTypeChoice[DayTypeChoice["Last"] = 0] = "Last";
})(DayTypeChoice = exports.DayTypeChoice || (exports.DayTypeChoice = {}));
var ID_LAST = DayTypeChoice[DayTypeChoice.Last];
var MonthlyRecurrencePane = /** @class */ (function (_super) {
    __extends(MonthlyRecurrencePane, _super);
    function MonthlyRecurrencePane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timeChangedHandler = function (time) { return _this.onStartTimeChange(time); };
        _this.dayChoiceChangedHandler = function (newDayChoiceIds) { return _this.onDayChoiceChange(newDayChoiceIds); };
        //public for being able to call it on the test.
        _this.monthDaysChangedHandler = function (newDayChoiceIds) { return _this.onMonthDaysChange(newDayChoiceIds); };
        _this.weekDaysChangedHandler = function (newDayChoiceIds) { return _this.onWeekDaysChange(newDayChoiceIds); };
        _this.MonthlyWeekdayDropDown = function () {
            return React.createElement(widgets_1.SingleSelectDropdown, { zIndex: 1031, className: typestyle_1.style(MonthDayPickerStyle), value: _this.getSelectedWeekdayOptionId(), onChange: _this.weekDaysChangedHandler, type: widgets_1.DropdownButtonType.Line, testId: _this.props.testWeekDayPickerId || 'MonthlyWeekdayDropDownId', list: _this.getMonthlyWeekday(), label: Localize_1.Messages.RecurrenceMonthlyDayOfWeek() });
        };
        _this.MonthlyDayTypeDropDown = function () {
            return (React.createElement(widgets_1.SingleSelectDropdown, { type: widgets_1.DropdownButtonType.Line, label: Localize_1.Messages.RecurrenceCaptionOn(), value: _this.getSelectedDayTypeOptionId(), testId: _this.props.testDayTypePickerId || 'testDayTypePickerIdDefaultTestId', list: _this.getMonthlyDayType(), onChange: _this.dayChoiceChangedHandler }));
        };
        return _this;
    }
    MonthlyRecurrencePane.prototype.onDayChoiceChange = function (newDayChoiceId) {
        var newDetails;
        if (newDayChoiceId === DayTypeChoice[DayTypeChoice.Day]) {
            newDetails = __assign({}, this.props.recurrenceDetails, { recurrenceDayOfMonth: StaticInitializers_1.StaticInitializers.DEFAULT_DAY_OF_MONTH_STR(), recurrenceDaysOfWeek: null });
        }
        else {
            var dayNumber = this.selectedDayOptionIdToDayNum(newDayChoiceId);
            newDetails = __assign({}, this.props.recurrenceDetails, { recurrenceDayOfMonth: Recurrence_1.RecurrenceConverters.toDaysOfMonthMask([dayNumber]) + '', recurrenceDaysOfWeek: [Recurrence_1.RecurrenceDaysOfTheWeek.Mon] });
        }
        this.props.recurrenceDetailsChangedCallback(newDetails);
    };
    MonthlyRecurrencePane.prototype.getSelectedDayTypeOptionId = function () {
        if (this.isWeekDayOptionCurrent()) {
            var daysOfMonth = Recurrence_1.RecurrenceConverters.toDaysOfMonthArr(this.props.recurrenceDetails.recurrenceDayOfMonth);
            return DayTypeChoice[daysOfMonth[0]];
        }
        return DayTypeChoice[DayTypeChoice.Day];
    };
    MonthlyRecurrencePane.prototype.onWeekDaysChange = function (weekDayIds) {
        var newDetails = __assign({}, this.props.recurrenceDetails, { recurrenceDaysOfWeek: [weekDayIds] });
        this.props.recurrenceDetailsChangedCallback(newDetails);
    };
    MonthlyRecurrencePane.prototype.mergeDaysOfMonth = function (newNumDayIds) {
        var isLastClicked = function (day) { return newNumDayIds.indexOf(day) === newNumDayIds.length - 1; };
        var newDaysOfMonthArr;
        // handle last specially
        // if last was selected we cannot possibly handle any other multiple options. By design.
        // one amendment: if user had last selected and selected another day - we actually would like to deselect last
        // and leave that day selected
        if (isLastClicked(DayTypeChoice.Last)) {
            return [0];
        }
        if (newNumDayIds.length === 0) {
            // user's playing with us - deselected all. well.. we'll select the default back!
            return [1];
        }
        newDaysOfMonthArr = [];
        newNumDayIds.forEach(function (dayNumId) {
            // last is handled in the if above
            if (dayNumId !== DayTypeChoice.Last) {
                newDaysOfMonthArr.push(dayNumId);
            }
        });
        return newDaysOfMonthArr;
    };
    // Used when only 1 day of month is allowed
    MonthlyRecurrencePane.prototype.getNewDayOfMonth = function (newNumDayIds) {
        if (newNumDayIds.length === 0) {
            // user's playing with us - deselected all. well.. we'll select the default back!
            return [1];
        }
        // Return last selected value
        return [newNumDayIds[newNumDayIds.length - 1]];
    };
    MonthlyRecurrencePane.prototype.onMonthDaysChange = function (newNumDayIds) {
        var newDaysOfMonthArr = this.props.allowMutlipleDaysOfMonth
            ? this.mergeDaysOfMonth(newNumDayIds)
            : this.getNewDayOfMonth(newNumDayIds);
        var newDetails = __assign({}, this.props.recurrenceDetails, { recurrenceDayOfMonth: Recurrence_1.RecurrenceConverters.toDaysOfMonthMask(newDaysOfMonthArr) + '' });
        this.props.recurrenceDetailsChangedCallback(newDetails);
    };
    MonthlyRecurrencePane.prototype.onStartTimeChange = function (time) {
        var newDetails = __assign({}, this.props.recurrenceDetails, { startTime: time.toNumber() });
        this.props.recurrenceDetailsChangedCallback(newDetails);
    };
    MonthlyRecurrencePane.prototype.selectedDayOptionIdToDayNum = function (dayOption) {
        switch (dayOption) {
            case DayTypeChoice[DayTypeChoice.Last]:
                return 0;
            case DayTypeChoice[DayTypeChoice.First]:
                return 1;
            case DayTypeChoice[DayTypeChoice.Second]:
                return 2;
            case DayTypeChoice[DayTypeChoice.Third]:
                return 3;
            case DayTypeChoice[DayTypeChoice.Fourth]:
                return 4;
            case DayTypeChoice[DayTypeChoice.Fifth]:
                return 5;
            default:
                throw dayOption + ' is not a number member of DayTypeChoice';
        }
    };
    MonthlyRecurrencePane.prototype.getSelectedWeekdayOptionId = function () {
        var daysOfWeek = this.props.recurrenceDetails.recurrenceDaysOfWeek;
        if (!daysOfWeek || daysOfWeek.length !== 1) {
            daysOfWeek = [Recurrence_1.RecurrenceDaysOfTheWeek.Mon];
        }
        // we currently support only one day of week with number qualifier in monthly
        return daysOfWeek[0];
    };
    MonthlyRecurrencePane.prototype.getSelectedMonthOptionId = function () {
        return Recurrence_1.RecurrenceConverters.toDaysOfMonthArr(this.props.recurrenceDetails.recurrenceDayOfMonth);
    };
    MonthlyRecurrencePane.prototype.getSelectedMonthOptionIdForDisplay = function () {
        var daysOfMonth = Recurrence_1.RecurrenceConverters.toDaysOfMonthArr(this.props.recurrenceDetails.recurrenceDayOfMonth);
        return daysOfMonth.map(function (dayOfMontAsNumber) { return dayOfMontAsNumber === 0
            ? Localize_1.Messages.RecurrenceMonthlyOnLast()
            : (dayOfMontAsNumber + ''); });
    };
    MonthlyRecurrencePane.prototype.isWeekDayOptionCurrent = function () {
        var recurrenceDaysOfWeek = this.props.recurrenceDetails.recurrenceDaysOfWeek;
        return recurrenceDaysOfWeek && recurrenceDaysOfWeek.length > 0;
    };
    //TODO: just found this to be a loc issue, as Sunday will always be on the top.
    MonthlyRecurrencePane.prototype.getMonthlyWeekday = function () {
        var results = [];
        results.push({
            value: Recurrence_1.RecurrenceDaysOfTheWeek.Sun,
            content: Localize_1.Messages.RecurrenceDayOfWeekSunday()
        });
        results.push({
            value: Recurrence_1.RecurrenceDaysOfTheWeek.Mon,
            content: Localize_1.Messages.RecurrenceDayOfWeekMonday()
        });
        results.push({
            value: Recurrence_1.RecurrenceDaysOfTheWeek.Tue,
            content: Localize_1.Messages.RecurrenceDayOfWeekTuesday()
        });
        results.push({
            value: Recurrence_1.RecurrenceDaysOfTheWeek.Wed,
            content: Localize_1.Messages.RecurrenceDayOfWeekWednesday()
        });
        results.push({
            value: Recurrence_1.RecurrenceDaysOfTheWeek.Thu,
            content: Localize_1.Messages.RecurrenceDayOfWeekThursday()
        });
        results.push({
            value: Recurrence_1.RecurrenceDaysOfTheWeek.Fri,
            content: Localize_1.Messages.RecurrenceDayOfWeekFriday()
        });
        results.push({
            value: Recurrence_1.RecurrenceDaysOfTheWeek.Sat,
            content: Localize_1.Messages.RecurrenceDayOfWeekSaturday()
        });
        return React.createElement(widgets_1.List, { items: results, style: { maxHeight: '200px', overflow: 'auto' } });
    };
    MonthlyRecurrencePane.prototype.getDayTypeDependentUx = function () {
        var _this = this;
        if (this.isWeekDayOptionCurrent()) {
            return (React.createElement(this.MonthlyWeekdayDropDown, null));
        }
        return React.createElement("div", { style: MonthDayPickerStyle },
            React.createElement(widgets_1.DropdownButton, { "aria-controls": MonthMultiDayPicker_1.DomId, children: this.getSelectedMonthOptionIdForDisplay().join(' | '), renderPopupContent: function () { return React.createElement(MonthMultiDayPicker_1.MonthMultiDayPicker, { monthDays: Recurrence_1.getDayOfMonthOptions(), selectedDayIds: _this.getSelectedMonthOptionId(), onSelectionChanged: _this.monthDaysChangedHandler, style: MonthMultiDayPickerStyle }); }, testId: this.props.testMonthDayPickerId || 'DayOfTheMonthTestId', type: widgets_1.DropdownButtonType.Line, label: Localize_1.Messages.RecurrenceMonthlyDaysOfMonth() }));
    };
    MonthlyRecurrencePane.prototype.getMonthlyDayType = function () {
        var results = [];
        results.push({
            value: DayTypeChoice[DayTypeChoice.Day],
            content: Localize_1.Messages.RecurrenceOnDay()
        });
        if (this.props.enableDayOfWeekMode) {
            results.push({
                value: DayTypeChoice[DayTypeChoice.First],
                content: Localize_1.Messages.RecurrenceMonthlyOnFirst()
            });
            results.push({
                value: DayTypeChoice[DayTypeChoice.Second],
                content: Localize_1.Messages.RecurrenceMonthlyOnSecond()
            });
            results.push({
                value: DayTypeChoice[DayTypeChoice.Third],
                content: Localize_1.Messages.RecurrenceMonthlyOnThird()
            });
            results.push({
                value: DayTypeChoice[DayTypeChoice.Fourth],
                content: Localize_1.Messages.RecurrenceMonthlyOnFourth()
            });
            results.push({
                value: DayTypeChoice[DayTypeChoice.Fifth],
                content: Localize_1.Messages.RecurrenceMonthlyOnFifth()
            });
            results.push({ value: ID_LAST, content: Localize_1.Messages.RecurrenceMonthlyOnLast() });
        }
        return React.createElement(widgets_1.List, { items: results, style: { maxHeight: '300px', overflow: 'auto' } });
    };
    MonthlyRecurrencePane.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(TimePicker_1.TimePicker, { caption: Localize_1.Messages.RecurrenceCaptionAt(), onTimeChange: this.timeChangedHandler, selectedValue: TimeHhMm_1.TimeHhMm.fromNumber(this.props.recurrenceDetails.startTime), style: TimePickerCssStyle, type: this.props.type, minuteInterval: Recurrence_1.getStartEndTimeMinuteInterval(this.props.type) }),
            React.createElement("div", { style: MonthDayTypePickerStyle },
                React.createElement(this.MonthlyDayTypeDropDown, null)),
            React.createElement(React.Fragment, null, this.getDayTypeDependentUx()),
            React.createElement("div", { style: TimeZoneCssStyle },
                React.createElement(TimeZoneDisplay_1.TimeZoneDisplay, { timeZoneDetails: this.props.timeZoneDetails, label: Localize_1.Messages.RecurrenceTimeZone(), onClick: this.props.onTimeZoneClick }))));
    };
    return MonthlyRecurrencePane;
}(React.Component));
exports.MonthlyRecurrencePane = MonthlyRecurrencePane;
//# sourceMappingURL=MonthlyRecurrencePane.js.map